import { isEcoFarmSupported } from 'utils/isNftStakingSupported'
import { useNFTStakingApproval as useFarmBoostNFTStakingApproval } from 'hooks/vvs-miner-mole/useMoleContract'
import { getRewarderV2AddressByPid, useArgoNFTStakingApproval } from 'hooks/rewarderV2/useRewarderV2Contract'
import { getVvsFarmBoostAddress } from 'utils/addressHelpers'

const useNFTStakingApproval = (farmId: number) => {
  const isEcoFarm = isEcoFarmSupported(farmId)

  const {
    approve: farmBoostApprove,
    isApproved: isFarmBoostApproved,
    isLoading: isFarmBoostGettingApproval,
  } = useFarmBoostNFTStakingApproval()
  const {
    approve: ArgoApprove,
    isApproved: isArgoApproved,
    isLoading: isArgoGettingApproval,
  } = useArgoNFTStakingApproval()

  let initialApprovalInfo = {
    approve: farmBoostApprove,
    isApproved: isFarmBoostApproved,
    isLoading: isFarmBoostGettingApproval,
    operatorAddress: getVvsFarmBoostAddress(),
  }

  if (isEcoFarm) {
    initialApprovalInfo = {
      ...initialApprovalInfo,
      approve: ArgoApprove,
      isApproved: isArgoApproved,
      isLoading: isArgoGettingApproval,
      operatorAddress: getRewarderV2AddressByPid(farmId),
    }
  }

  return initialApprovalInfo
}

export default useNFTStakingApproval
